<template>
  <div class="lottery-page page">
    <div class="top-bar">
      <button type="button" class="back-btn" @click="back">
        <van-icon name="arrow-left" />
      </button>
      <div class="top-title"></div>
      <button type="button" class="history-btn" @click="goGameRecord">
        {{ $t("lottery.voting_history") }}
      </button>
    </div>

    <div class="record-card">
      <div class="period-row">
        <div class="period-number">{{ lottery.now_expect || "--" }}</div>
        <van-count-down
          class="count-down"
          :time="time"
          format="HH:mm:ss"
          @finish="check"
        />
      </div>

      <div class="divider"></div>

      <div class="recent-row" @click="active = !active">
        <div class="recent-text">{{ currentResultText }}</div>
        <van-icon :name="active ? 'arrow-up' : 'arrow-down'" />
      </div>
    </div>

    <div v-if="active" class="history-inline">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="history-table">
          <div class="history-head">
            <div>{{ $t("lottery.issue") }}</div>
            <div>{{ $t("lottery.winning_numbers") }}</div>
          </div>
          <div
            v-for="(item, index) in historyRows"
            :key="index"
            class="history-row"
          >
            <div class="history-expect">{{ item.expect }}</div>
            <div class="history-result">{{ item.result }}</div>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <div class="options-grid">
      <div
        v-for="item in optionCards"
        :key="item.type"
        class="option-card"
        :class="{ active: choose[item.type] }"
        @click="choosePlay(item.type, item.label)"
      >
        <img :src="item.icon" :alt="item.label" class="option-icon" />
        <div class="option-label">{{ item.label }}</div>
      </div>
    </div>

    <div class="live-card">
      <div class="live-header">{{ $t("lottery.watch_live_vote") }}</div>
      <div ref="liveList" class="live-list">
        <div
          v-for="(message, index) in liveVoteMessages"
          :key="index"
          class="live-item"
        >
          {{ message }}
        </div>
      </div>
    </div>

    <div v-if="formData.length > 0" class="bet-panel">
      <div class="bet-title">{{ betTitle }}</div>
      <div class="bet-row">
        <div class="bet-label">{{ $t("lottery.dot") }}</div>
        <div class="bet-input-wrap">
          <van-field
            v-model="money"
            type="digit"
            class="bet-input"
            :placeholder="$t('lottery.amount_placeholder')"
          />
        </div>
        <button type="button" class="rewind-btn" @click="allClear">{{ $t("lottery.rewind") }}</button>
      </div>
      <button type="button" class="vote-btn" @click="jiesuan">{{ $t("lottery.vote") }}</button>
    </div>

    <van-popup v-model="jiesuanpage" get-container="body" class="mission-popup">
      <div class="mission-card">
        <div class="mission-title">{{ $t("lottery.mission_list") }}</div>
        <div class="mission-list">
          <div
            v-for="(v, key) in formData"
            :key="key"
            class="mission-item"
          >
            <div class="mission-main">
              <div class="mission-name">{{ getTypeLabel(v.type) }}</div>
              <div class="mission-detail">
                {{ missionDetailText }}
              </div>
            </div>
            <van-icon name="close" class="mission-close" @click="clearChooes(v.type)" />
          </div>
        </div>
        <div class="mission-actions">
          <button type="button" class="clear-btn" @click="allClear">{{ $t("lottery.clear_order") }}</button>
          <button type="button" class="submit-btn" @click="doSub">{{ $t("lottery.submit") }}</button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
let refreshTimer;
let count = 0;
let liveScrollTimer;

export default {
  data() {
    return {
      jiesuanpage: false,
      isLoading: false,
      lottery_peilv_list: [],
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      sum: 0,
      size: "",
      double: "",
      time: 0,
      formData: [],
      money: "",
      ids: this.$route.query.id,
      keys: this.$route.query.key,
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
      },
      labelMap: {
        rose: "",
        heart: "",
        balloon: "",
        rocket: "",
      },
    };
  },
  computed: {
    optionCards() {
      const iconMap = {
        big: "/img/eharmony-home/rose.png",
        two: "/img/eharmony-home/balloon.png",
        small: "/img/eharmony-home/heart.png",
        one: "/img/eharmony-home/rocket.png",
      };
      const order = ["big", "two", "small", "one"];
      const oddsMap = {};
      (this.lottery_peilv_list || []).forEach((item) => {
        oddsMap[item.type || item.name] = item;
      });
      return order.map((type) => ({
        type,
        icon: iconMap[type],
        label: this.getTypeLabel(type),
        proportion: oddsMap[type] ? oddsMap[type].proportion : "",
      }));
    },
    currentResultText() {
      return [this.size, this.double].filter(Boolean).join(" ");
    },
    historyRows() {
      return (this.lottery_list || []).map((item) => ({
        expect: item.expect,
        result: this.formatResult(item.opencode || []),
      }));
    },
    liveVoteMessages() {
      const rows = this.historyRows.slice(0, 14).map((item, index) => {
        const round = index % 2 === 0
          ? this.$t("lottery.first_round")
          : this.$t("lottery.second_round");
        return this.$t("lottery.live_vote_message", {
          round,
          expect: item.expect,
        });
      });
      if (rows.length > 0) {
        return rows;
      }
      return [
        this.$t("lottery.live_vote_message", {
          round: this.$t("lottery.first_round"),
          expect: "A*7X9",
        }),
        this.$t("lottery.live_vote_message", {
          round: this.$t("lottery.second_round"),
          expect: "B****3L4",
        }),
        this.$t("lottery.live_vote_message", {
          round: this.$t("lottery.first_round"),
          expect: "C****8M2",
        }),
        this.$t("lottery.live_vote_message", {
          round: this.$t("lottery.second_round"),
          expect: "D****5N6",
        }),
      ];
    },
    moneyNumber() {
      return this.money || 0;
    },
    betTitle() {
      return this.$t("lottery.bet_title", {
        count: this.formData.length,
        money: this.moneyNumber,
      });
    },
    missionDetailText() {
      return this.$t("lottery.mission_detail", {
        money: this.money || 0,
      });
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    goGameRecord() {
      this.$router.push({ path: "/GameRecord" });
    },
    getTypeLabel(type) {
      const mapping = {
        big: this.labelMap.rose,
        small: this.labelMap.heart,
        one: this.labelMap.rocket,
        two: this.labelMap.balloon,
      };
      return mapping[type] || type;
    },
    formatResult(opencode) {
      if (!Array.isArray(opencode) || opencode.length < 3) {
        return this.currentResultText || "--";
      }
      const total =
        Number(opencode[0] || 0) +
        Number(opencode[1] || 0) +
        Number(opencode[2] || 0);
      const sizeText = total >= 11 ? this.labelMap.rose : this.labelMap.heart;
      const parityText = total % 2 === 0 ? this.labelMap.balloon : this.labelMap.rocket;
      return `${sizeText} ${parityText}`;
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }
      if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      if (this.userInfo.money - this.money * this.formData.length < 0) {
        this.$toast(this.$t("reservation.balance_enough"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          item: this.formData.map((item) => item.type).join(","),
          money: this.money,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect,
        },
        url: "game_place_order",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.allClear();
          this.getUserInfo();
          this.getLotteryInfo();
          this.getLotteryList();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });

      return true;
    },
    allClear() {
      Object.keys(this.choose).forEach((key) => {
        this.choose[key] = false;
      });
      this.formData = [];
      this.money = "";
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }
      if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      this.jiesuanpage = true;
      return true;
    },
    clearChooes(type) {
      this.formData = this.formData.filter((item) => item.type !== type);
      if (this.choose[type] !== undefined) {
        this.choose[type] = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type) {
      if (this.choose[type]) {
        this.choose[type] = false;
        this.formData = this.formData.filter((item) => item.type !== type);
        return;
      }

      this.choose[type] = true;
      this.formData.push({ type });
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }

      refreshTimer = window.setInterval(() => {
        setTimeout(() => {
          this.getUserInfo();
          this.getLotteryInfo();
          this.getLotteryList();
          count += 1;
          if (count > 5) {
            clearInterval(refreshTimer);
            count = 0;
          }
        }, 0);
      }, 300);
    },
    onRefresh() {
      setTimeout(() => {
        this.getLotteryList();
        this.isLoading = false;
        this.$toast(this.$t("reservation.refresh"));
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = Array.isArray(res.data) ? res.data : [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = Array.isArray(res.data) ? res.data : [];
          this.getLotteryPeilv();
          this.$nextTick(() => {
            this.startLiveAutoScroll();
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    startLiveAutoScroll() {
      this.stopLiveAutoScroll();
      const container = this.$refs.liveList;
      if (!container) {
        return;
      }
      if (container.scrollHeight <= container.clientHeight) {
        container.scrollTop = 0;
        return;
      }
      liveScrollTimer = window.setInterval(() => {
        const list = this.$refs.liveList;
        if (!list) {
          return;
        }
        const maxScrollTop = list.scrollHeight - list.clientHeight;
        if (list.scrollTop >= maxScrollTop) {
          list.scrollTop = 0;
          return;
        }
        list.scrollTop += 1;
      }, 45);
    },
    stopLiveAutoScroll() {
      clearInterval(liveScrollTimer);
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lang = this.$t("auth.lang");
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return;
          }
          this.lottery = res.data;
          this.time = Number(res.data.second || 0) * 1000;

          if (lang === "en") {
            this.lottery.name = res.data.name_es;
          } else if (lang === "ja") {
            this.lottery.name = res.data.name_ja;
          } else if (lang === "kr") {
            this.lottery.name = res.data.name_kr;
          }

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }

          const opencode = Array.isArray(res.data.opencode) ? res.data.opencode : [0, 0, 0];
          this.sum =
            Number(opencode[0] || 0) +
            Number(opencode[1] || 0) +
            Number(opencode[2] || 0);

          this.size = this.sum >= 11 ? this.labelMap.rose : this.labelMap.heart;
          this.double = this.sum % 2 === 0 ? this.labelMap.balloon : this.labelMap.rocket;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    initLabels() {
      this.labelMap = {
        rose: this.$t("lottery.labels.rose"),
        heart: this.$t("lottery.labels.heart"),
        balloon: this.$t("lottery.labels.balloon"),
        rocket: this.$t("lottery.labels.rocket"),
      };
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return;
    }
    this.initLabels();
    this.getUserInfo();
    this.getLotteryInfo();
    this.getLotteryList();
  },
  mounted() {
    this.$nextTick(() => {
      this.startLiveAutoScroll();
    });
  },
  destroyed() {
    clearInterval(refreshTimer);
    this.stopLiveAutoScroll();
  },
};
</script>

<style scoped lang="less">
.lottery-page {
  min-height: 100%;
  padding-bottom: 280px;
  background: #f5f5f5;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 96px;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #ececec;
}

.back-btn,
.history-btn {
  border: none;
  background: transparent;
}

.back-btn {
  width: 52px;
  height: 52px;
  padding: 0;
  color: #4f5665;
}

.back-btn .van-icon {
  font-size: 32px;
}

.top-title {
  flex: 1;
}

.history-btn {
  color: #111;
  font-size: 30px;
  line-height: 38px;
}

.record-card {
  padding: 16px 20px 18px;
  background: #fff;
}

.period-row,
.recent-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 116px;
}

.period-number,
.recent-text {
  color: #5863eb;
  font-size: 40px;
  line-height: 50px;
  font-weight: 700;
}

.count-down {
  color: #ff3a3a;
  font-size: 40px;
  line-height: 50px;
  font-weight: 500;
}

.divider {
  height: 1px;
  background: #e9e9e9;
}

.recent-row .van-icon {
  color: #202020;
  font-size: 36px;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px 24px;
  padding: 42px 24px 0;
}

.option-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 210px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.option-card.active {
  background: #6577f0;
}

.option-icon {
  width: 104px;
  height: 104px;
  object-fit: contain;
}

.option-label {
  margin-top: 16px;
  color: #1f2230;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
}

.option-card.active .option-label {
  color: #fff;
}

.live-card {
  margin: 28px 24px 0;
  overflow: hidden;
  background: #fff;
  border: 2px solid #6577f0;
  border-radius: 16px;
  box-shadow: 0 8px 22px rgba(101, 119, 240, 0.18);
}

.live-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  color: #fff;
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
  background: #6577f0;
}

.live-list {
  height: 540px;
  max-height: 540px;
  overflow-y: auto;
  background: #fff;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.live-list::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.live-item {
  padding: 16px 16px 15px;
  color: #777;
  font-size: 15px;
  line-height: 22px;
  border-bottom: 1px solid #ededed;
}

.bet-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 22px 18px calc(22px + env(safe-area-inset-bottom));
  background: #fbfbff;
  border-top: 2px solid rgba(101, 119, 240, 0.18);
  border-radius: 26px 26px 0 0;
  box-shadow: 0 -10px 30px rgba(101, 119, 240, 0.18);
}

.bet-title {
  color: #6577f0;
  font-size: 19px;
  line-height: 28px;
  font-weight: 600;
}

.bet-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 24px;
}

.bet-label {
  color: #6577f0;
  font-size: 18px;
  line-height: 24px;
}

.bet-input-wrap {
  flex: 1;
}

::v-deep .bet-input.van-cell {
  min-height: 48px;
  padding: 0 18px;
  background: #efefef;
  border-radius: 12px;
}

::v-deep .bet-input .van-field__control {
  color: #d13a3a;
  font-size: 16px;
}

::v-deep .bet-input .van-field__control::placeholder {
  color: #c1c1c1;
}

.rewind-btn,
.vote-btn,
.clear-btn,
.submit-btn {
  border: none;
}

.rewind-btn {
  width: 84px;
  height: 48px;
  color: #666;
  font-size: 15px;
  background: #efefef;
  border-radius: 12px;
}

.vote-btn {
  width: 100%;
  height: 66px;
  margin-top: 24px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(180deg, #7485ff, #5f71ee);
  border-radius: 16px;
  box-shadow: 0 8px 18px rgba(101, 119, 240, 0.28);
}

.mission-popup {
  background: transparent;
}

.mission-card {
  width: 470px;
  min-height: 540px;
  padding: 0 28px 28px;
  background: #fff;
  border-radius: 32px;
}

.mission-title {
  padding: 20px 0 16px;
  color: #6577f0;
  font-size: 28px;
  line-height: 38px;
  text-align: center;
}

.mission-list {
  min-height: 300px;
  max-height: 380px;
  overflow-y: auto;
}

.mission-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 0;
  border-top: 1px solid #ececec;
}

.mission-main {
  flex: 1;
}

.mission-name {
  color: #ff4343;
  font-size: 24px;
  line-height: 32px;
}

.mission-detail {
  margin-top: 2px;
  color: #8d8d8d;
  font-size: 22px;
  line-height: 30px;
}

.mission-close {
  margin-top: 2px;
  color: #ff4343;
  font-size: 24px;
}

.mission-actions {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  margin-top: 28px;
}

.clear-btn,
.submit-btn {
  flex: 1;
  height: 52px;
  border-radius: 26px;
  font-size: 22px;
}

.clear-btn {
  color: #8b8b8b;
  background: #fff;
  border: 1px solid #9e9e9e;
}

.submit-btn {
  color: #fff;
  background: #6577f0;
}

.history-inline {
  margin: 0 20px;
  background: #fff;
}

.history-table {
  padding: 20px 8px 16px;
}

.history-head,
.history-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 16px;
}

.history-head {
  color: #5863eb;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  margin-bottom: 12px;
}

.history-row {
  padding: 10px 0;
}

.history-expect,
.history-result {
  color: #5863eb;
  font-size: 17px;
  line-height: 25px;
  font-weight: 600;
  word-break: break-word;
}

::v-deep .van-popup--center {
  border-radius: 28px;
}

::v-deep .van-count-down {
  color: #ff3a3a;
  font-size: 40px;
  line-height: 50px;
}
</style>
